import React, { useState, useEffect, useRef } from 'react';

export default function LocationSearchInput({ 
    initialValue, 
    onPlaceSelected, 
    isFormInput = false, 
    placeholder = "Location (e.g., San Francisco)", 
    autocompleteType = '(cities)', 
    isMapsScriptLoaded, 
    className 
}) {
    const inputRef = useRef(null);
    const [inputValue, setInputValue] = useState(initialValue || '');

    useEffect(() => {
        setInputValue(initialValue || '');
    }, [initialValue]);

    useEffect(() => {
        if (isMapsScriptLoaded && window.google && inputRef.current) {
            const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
                types: [autocompleteType],
                componentRestrictions: { country: 'us' }
            });
            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                const formattedAddress = place.formatted_address || '';
                setInputValue(formattedAddress);
                onPlaceSelected(formattedAddress);
            });
        }
    }, [isMapsScriptLoaded, onPlaceSelected, autocompleteType]);

    const handleChange = (e) => {
        setInputValue(e.target.value);
        if (!isFormInput) {
             onPlaceSelected(e.target.value);
        }
    };

    const defaultClassName = isFormInput
        ? "w-full p-2 border rounded-md"
        : "w-full p-3 border-none focus:ring-0 rounded-full";

    return (
        <input
            ref={inputRef}
            type="text"
            placeholder={placeholder}
            className={className || defaultClassName}
            value={inputValue}
            onChange={handleChange}
        />
    );
}